import styleVariables from 'styles/variables.module.scss'

export const getColor = ({ suffix } = { suffix: 'color-' }) => {
    return Object.fromEntries(
        Object.entries(styleVariables)
            .filter(([ key ]) => key.startsWith(suffix))
            .map(([ key, value ]) => [key.substring(6), value])
    )
}